import React, { useEffect, useMemo, useState } from "react";
import { api, fmtUSD, fmtDate } from "../lib/api";

const Transactions = () => {
  const [txns, setTxns] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [filter, setFilter] = useState("all");
  const [accountId, setAccountId] = useState("all");

  useEffect(() => {
    Promise.all([api.get("/transactions"), api.get("/accounts")]).then(([t, a]) => {
      setTxns(t.data); setAccounts(a.data);
    });
  }, []);

  const filtered = useMemo(() => {
    let r = txns;
    if (filter === "in") r = r.filter(t => t.amount >= 0);
    if (filter === "out") r = r.filter(t => t.amount < 0);
    if (accountId !== "all") r = r.filter(t => t.account_id === accountId);
    return r;
  }, [txns, filter, accountId]);

  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Ledger</div>
        <h1 className="font-display text-4xl mt-1">Activity</h1>
      </div>

      <div className="flex flex-wrap gap-3 items-center">
        <div className="flex gap-1 border border-[hsl(var(--border))]">
          {[["all", "All"], ["in", "Money in"], ["out", "Money out"]].map(([k, l]) => (
            <button key={k} onClick={() => setFilter(k)}
              className={`px-4 py-2 text-sm ${filter === k ? "bg-[hsl(var(--primary))] text-white" : "hover:bg-[hsl(var(--surface-alt))]"}`}
              data-testid={`filter-${k}`}>{l}</button>
          ))}
        </div>
        <select value={accountId} onChange={(e) => setAccountId(e.target.value)}
          className="bg-transparent border border-[hsl(var(--border))] px-3 py-2 text-sm"
          data-testid="filter-account">
          <option value="all">All accounts</option>
          {accounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        <div className="overline ml-auto" data-testid="txns-count">{filtered.length} entries</div>
      </div>

      <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))]">
        <table className="w-full text-sm">
          <thead className="border-b border-[hsl(var(--border))]">
            <tr className="text-left">
              <th className="overline py-3 px-4">Date</th>
              <th className="overline py-3 px-4">Type</th>
              <th className="overline py-3 px-4">Description</th>
              <th className="overline py-3 px-4">Counterparty</th>
              <th className="overline py-3 px-4 text-right">Amount</th>
              <th className="overline py-3 px-4 text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((t) => (
              <tr key={t.id} className="border-b border-[hsl(var(--border))] hover:bg-[hsl(var(--surface-alt))]" data-testid={`row-${t.id}`}>
                <td className="py-3 px-4 font-mono text-xs">{fmtDate(t.created_at)}</td>
                <td className="py-3 px-4 capitalize">{t.type.replace(/_/g, " ")}</td>
                <td className="py-3 px-4">{t.description}</td>
                <td className="py-3 px-4 font-mono text-xs text-[hsl(var(--text-muted))]">{t.counterparty || "—"}</td>
                <td className={`py-3 px-4 text-right font-mono ${t.amount >= 0 ? "text-[hsl(var(--primary))]" : ""}`}>
                  {t.amount >= 0 ? "+" : ""}{fmtUSD(t.amount)}
                </td>
                <td className="py-3 px-4 text-right font-mono">{fmtUSD(t.balance_after)}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="py-12 text-center text-[hsl(var(--text-muted))]">No transactions match the filter.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Transactions;
